<template>
  <section class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="11">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Accession / Patient Name"
                    v-model="search_string"
                    @input="getAutoCompleteCases()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getIsValidationCases.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="120"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession">
                  <span id="accession-id" @click="goToCaseView(scope.row._id)">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              prop="case_types"
              min-width="125px"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="140"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))"
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" width="100">
              <template #default="scope">
                <span v-if="scope.row.patient_info">
                  {{
                    scope.row.patient_info.date_of_birth
                      ? formatDate(scope.row.patient_info.date_of_birth)
                      : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ordering_facility"
              label="ORDERING FACILITIES"
              min-width="215"
              class="ordering_facility"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Physician" min-width="120">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.name.includes("Dr")
                          ? scope.row.ordering_physician.name
                          : "Dr " + scope.row.ordering_physician.name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Collected On"
              min-width="135"
              prop="collection_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.collection_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="125"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              width="130"
              sortable="custom"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status" v-if="scope.row.status">
                  <div
                    class="status-dropdown"
                    v-if="hasPermission('cases', 'update_status')"
                  >
                    <span class="el-dropdown-link">
                      <el-tag :type="getStatusType(scope.row.status)">
                        {{
                          scope.row.status === "COMPLETE"
                            ? "FINALIZED"
                            : scope.row.status === "TEST_REPORTS"
                            ? "PROCESSING"
                            : scope.row.status.split("_").join(" ")
                        }}
                      </el-tag>
                    </span>
                  </div>

                  <el-tag
                    v-else-if="isFacilityUser"
                    :type="getStatusType(scope.row.status)"
                    >{{
                      scope.row.status === "COMPLETE"
                        ? "FINALIZED"
                        : "PROCESSING"
                    }}</el-tag
                  >
                  <el-tag v-else :type="getStatusType(scope.row.status)">
                    <span v-if="scope.row.status === 'TEST_REPORTS'"
                      >PROCESSING</span
                    >
                    <span v-else-if="scope.row.status === 'COMPLETE'"
                      >FINALIZED</span
                    >
                    <span v-else>{{
                      scope.row.status.split("_").join(" ")
                    }}</span>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Reported On"
              width="120"
              prop="reported_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.reported_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.reported_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="90"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="hasPermission('validations', 'cases')">
                    <el-button
                      title="Restore Validation"
                      class="reports-button"
                      @click="moveToValidations(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getIsValidationCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <ResonForValidation
      v-if="takeValidationReasonDialog"
      v-on:close="takeValidationReasonDialog = false"
      v-on:reasonSubmit="moveToValidation"
      title="Reason for Restore"
    ></ResonForValidation>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import { casesExtraSearchOptions } from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import AppHelper from "@/mixins/AppHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ResonForValidation = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
export default {
  name: "allCases",
  components: {
    ResonForValidation,
  },
  computed: {
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "ACCOUNT_MANAGER"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("cases", [
      "getUpdateCaseCovidStatus",
      "getCaseDeleteStatus",
      "getUpdateCaseStatus",
      "getRestoreCaseStatus",
      "getSendAccessionToLabdaq",
      "getSyncAccessionToLabdaq",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
      "getSendToLabdaqValiationError",
      "getUpdateValidationStatus",
    ]),
    checkCaseStatus() {
      return (caseData) => {
        if (caseData.status === "COMPLETE") {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          let newReport = caseData.test_reports.find((report) => {
            if (report.download_logs) {
              let userDownloadLog = report.download_logs.find(
                (e) => e.user_id === this.getAuthenticatedUser._id
              );
              if (userDownloadLog) {
                return false;
              } else {
                return true;
              }
            }
          });
          if (newReport) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("cases", ["getIsValidationCases"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    ...mapGetters("errors", ["getErrors", "getError"]),
    checkLab() {
      if (
        this.getProfileData &&
        this.getProfileData.lab &&
        this.getProfileData.lab.lab_code === "DLW"
      ) {
        return true;
      }
      return false;
    },
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  mixins: [FilterHelper, UserPermissionsHelper, AppHelper, caseDataHelper],
  data() {
    return {
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      search_string: "",
      loading: false,
      orderBy: "created_at",
      orderType: "DESC",
      caseType: "",
      caseTypes: caseConstants.CASE_TYPES_DATA,
      requestValidationCase: "",
      takeValidationReasonDialog: false,
    };
  },

  mounted() {
    this.initData();
  },
  methods: {
    async moveToValidations(validation) {
      this.requestValidationCase = validation;
      this.takeValidationReasonDialog = true;
    },
    async moveToValidation(reason) {
      try {
        this.loading = true;
        let params = {
          id: this.requestValidationCase,
          status: false,
          validation_reason: reason,
        };
        await this.$store.dispatch("cases/changeCaseValidationStatus", params);
        if (this.getUpdateValidationStatus) {
          successNotification("Validation case restored to All Cases");
          await this.fetchValidationCases();
        } else {
          errorNotification("Error while restoring validation case");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async initData() {
      this.setQueryParamsData();
      await Promise.all([this.fetchValidationCases()]);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedCaseOrderBy) {
        this.orderBy = this.$route.query.selectedCaseOrderBy;
      }
      if (this.$route.query.selectedCaseOrderType) {
        this.orderType = this.$route.query.selectedCaseOrderType;
      }
    },
    prepareParams() {
      this.pregnant = "";
      const params = {
        page: this.page,
        limit: this.pageSize,
        is_validation_purpose: true,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      if(this.isGowthamUser){
        params.is_old = true
      }
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchValidationCases();
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchValidationCases();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchValidationCases();
    },
    clearTest() {
      this.caseType = "";
      this.test_info = [];
      this.fetchValidationCases();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchValidationCases();
    },
    async fetchValidationCases() {
      try {
        let params = this.prepareParams();
        this.loading = true;
        await this.$store.dispatch("cases/fetchAllValidationCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    goToCaseView(caseId) {
      if (this.$route.query.selected_panel) {
        this.$route.query.selected_panel = undefined;
      }
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedCaseOrderBy: params.order_by,
        selectedCaseOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
  },
};
</script>

<style lang="scss">
.test-reports {
  display: flex;
  align-items: center;
  padding: 4px 5px;
  .regular-reports {
    &.single-report {
      margin-left: 20px;
    }
    h5 {
      color: #0a5da6;
      font-size: 14px;
      span {
        color: #bdbdbd;
      }
    }
  }
  .repots {
    h5 {
      color: #0a5da6;
    }
  }
}

.test-tabs {
  padding: 0;

  .el-tabs__active-bar {
    height: 3px;
    background-color: #0a5da6;
    border-radius: 25px;
  }
  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 600;
  }

  .el-tabs__item {
    color: #828282;
  }
  .el-tabs__nav-scroll {
    padding: 0 18px;
  }

  .types {
    padding: 0 5px;
    .case-type {
      &.view-reports-dialog {
        .el-button {
          width: 100%;
          min-height: 36px;
          padding: 0 17px;
          background-color: #f2f6f9;
          border: 1px dashed #bababc;

          span {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin-right: 6px;
            }
            p {
              margin-left: 8px;
              color: #828282;
            }
          }
        }
      }
      .el-input__inner {
        height: 36px;
        border: 1px solid rgba(86, 204, 242, 0.8);
      }
    }
    .btn {
      margin-top: 23px;
      .el-button {
        min-height: 36px;
        padding: 8px 24px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 7px;
      }
    }
  }
  .mark {
    margin-left: 15px;
  }
  .panel {
    .documents {
      display: none;
    }
    .el-table__header {
      color: rgba(0, 0, 0, 0.8);
      // background: #e5e5e5;
      border-spacing: 0 5.5px;
      border-radius: 25px;
    }
    .el-table {
      background: rgb(238, 242, 245);
      .el-table__cell {
        padding: 5px 0;
      }
      .el-table__header-wrapper {
        border-radius: 10px;
      }
      .el-table__body-wrapper {
        border-radius: 6px;
      }
      .el-table__cell {
        .cell {
          font-weight: 500;
        }
      }
    }
    .el-table thead {
      color: rgba(0, 0, 0, 0.8);
    }
    .physician-btn {
      .el-switch .el-switch__core {
        width: 34px !important;
        height: 15px;
        background-color: #0a5da6;
        border: none;
        .el-switch__action {
          top: 3px;
          left: 2px;
          width: 9px;
          height: 9px;
        }
      }
      .el-switch__label.is-active {
        color: #0a5da6;
      }
      .el-switch.is-checked {
        .el-switch__core {
          width: 34px !important;
          height: 15px;
          background-color: #4bb543 !important;
          border: none;
        }
        .el-switch__action {
          top: 2.2px;
          left: 38.5px;
          width: 10px;
          height: 10px;
        }
      }
    }
    .title {
      color: #2f80ed;
      img {
        color: #eb5757;
        vertical-align: middle;
      }
    }
  }
  .action-test-icons {
    display: flex;
    li {
      margin-right: 10px;
      .el-button {
        min-height: auto;
        padding: 0;
        background: none;
        border: none;
        transition: all 0.2s;

        &:hover {
          background-color: #eef2f5;
        }
        &:active {
          background-color: #eef2f5;
        }
        &:focus {
          background-color: #eef2f5;
        }
        img {
          color: red;
          &:hover {
            color: #0a5da6;
          }
        }
      }
    }
  }
}
.documents {
  padding: 0 20px;
  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 500;
  }
  .el-tabs__active-bar {
    background-color: #0a5da6;
    border-radius: 25px;
  }
  .document-container {
    display: grid;
    align-items: center;

    gap: 10px;
    grid-template-columns: 230px 230px;
  }
  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 75% 8% 10%;
    img {
      width: 18px;
      height: 18px;
    }
    .cancel {
      width: 15px;
      height: 15px;
    }
    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 500;
    }
    .demo-progress {
      .el-progress--line {
        width: 230px;
        .el-progress-bar__outer {
          height: 5px !important;
          background-color: #9ae0f7;
        }
        .el-progress-bar__inner {
          height: 5px;
          background-color: #2d9cdb;
        }
      }
      .el-progress__text {
        color: #828282;
      }
    }
  }
  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 80% 8% 10%;
    img {
      width: 18px;
      height: 18px;
    }
    .cancel {
      width: 15px;
      height: 15px;
    }
    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
}
.listings-navbar {
  .barcode-print {
    .el-button--small {
      padding: 7px 15px;
      border-radius: 8px;
      &:hover {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
      &:focus {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
      &:active {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
    }
  }
}
.btn-synced {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}
.btn-sync {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #5162fd;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #5162fd;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
}
.btn-processing {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #f28b0c;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #f28b0c;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #f28b0c;
    color: #f28b0c;
  }
}
</style>
